const CHEKA_EVENTS = {
  PAGE_INIT: {
    id: 1309219,
    text: '页面初始化',
  },
  NOT_LOGIN: {
    id: 1309221,
    text: '未检测到用户信息',
  },
  ACTION_SUCCESS: {
    id: 1309222,
    text: '操作成功',
  },
  ACTION_FAILD: {
    id: 1309226,
    text: '操作失败',
  },
  ACTION_CANCEL: {
    id: 1309342,
    text: '操作失败',
  }
};

const CHEKA_EVENT_TYPE = {
  BEFORE_PUT_ON: {
    name: 'before_put_on'
  },
  AFTER_PUT_ON: {
    name: 'after_put_on'
  },
  BEFORE_TAKE_OFF: {
    name: 'before_take_off'
  },
  AFTER_TAKE_OFF: {
    name: 'after_take_off'
  },
};

function getCheka() {
  if (window.wbadmt && window.wbadmt.send) {
    return window.wbadmt;
  }
  return null;
}

function cheka(functionName, ...args) {
  const c = getCheka();
  if (!c) {
    window.addEventListener('cheka:ready', function() {
      getCheka()[functionName](...args);
    });
  } else {
    c[functionName](...args);
  }
}

function sendCheka(...args) {
  cheka('send', ...args);
}

function sendError(...args) {
  cheka('captureError', ...args);
}

export default cheka;
export {cheka, CHEKA_EVENTS, CHEKA_EVENT_TYPE, sendCheka, sendError };
